import { useEffect } from 'react';

import useOverlayStatus from '../../components/OverlayStatusContext/useOverlayStatus';
import useBookingFormProps from '../../pages/BookingForm/hooks/useBookingFormProps';

const useAutoForceOverlayMode = () => {
    const { forceOverlay } = useOverlayStatus();
    const { uiParameters } = useBookingFormProps();

    useEffect(() => {
        if (!uiParameters?.forceOverlayMode) {
            return;
        }

        forceOverlay();
    }, [uiParameters?.forceOverlayMode, forceOverlay]);
};

export default useAutoForceOverlayMode;
